import React from 'react';
import ZenLoading from '../../loading/Loading';

const FallbackPage = () => {
    return (
        <div className={`flex flex-auto items-center justify-center`}>
            <ZenLoading />
        </div>
    );
};

export default FallbackPage;
